import styles from './tooltip.module.scss';
import MaterialTooltip from '@mui/material/Tooltip';

/* eslint-disable-next-line */
export interface TooltipProps {
  children: any,
  title?: any,
  arrow?: boolean,
  // classes?: object,
  // components?: { Arrow?: any, Popper?: any, Tooltip?: any, Transition?: any },
  componentsProps?: object,
  // describeChild?: boolean,
  // disableFocusListener?: boolean,
  disableHoverListener?: boolean,
  // disableInteractive?: boolean,
  // disableTouchListener?: boolean,
  // enterDelay?: number,
  // enterNextDelay?: number,
  // enterTouchDelay?: number,
  // followCursor?: boolean,
  // id?: string,
  // leaveDelay?: number,
  // leaveTouchDelay?: number,
  onClose?: (event: any) => void,
  onOpen?: (event: any) => void,
  // open?: boolean,
  placement?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top',
  // PopperComponent?: any,
  // PopperProps?: object,
  sx?: any,
  // TransitionComponent?: any,
  // TransitionProps?: object
  className?: string,
  ['data-testid']?: string
}

export function Tooltip(props: TooltipProps) {
  return (
    props.title ?
      <MaterialTooltip
        title={props.title}
        arrow={props.arrow}
        placement={props.placement || 'top'}
        className={props.className}
        onOpen={props.onOpen}
        onClose={props.onClose}
        sx={props.sx}
        componentsProps={props.componentsProps}
        disableHoverListener={props.disableHoverListener}
        data-testid={props['data-testid']}>
        <div>
          {props.children}
        </div>
      </MaterialTooltip> : <>{props.children}</>
  );
}

export default Tooltip;